module.exports = __webpack_public_path__ + "static/media/bonian_factory_profile.d007856f.pdf";